// © Microsoft Corporation. All rights reserved.

import { TelemetryBehaviorType, TelemetryObjectBase, TelemetryType } from "@msnews/telemetry-contracts";

import { genericTelemetryClickDispatcher } from "@msnews/social-utils";

export interface PopupTelemetryObjects {
    closeBtn: TelemetryObjectBase;
}

export const popupTelemetryContracts = {
    closeBtn: {
        name: "CloseDialog",
        behavior: TelemetryBehaviorType.Close,
        content: {
            headline: "Close"
        }
    }
};

export const popupTelemetryActionDispatchers = {
    /** Used for: Scenario 3a and Scenario 4a */
    genericClicked: genericTelemetryClickDispatcher
};